import { animateScroll } from '@/utils';

export default {
  name: 'scroll-to',
  bind(el, binding) {
    const targetElement = document.getElementById(binding.value);
    if (!targetElement) return;
    const speed = binding.arg ? +binding.arg : 2000;
    const ease = binding.modifiers && Object.keys(binding.modifiers).length
      ? Object.keys(binding.modifiers)[0] : '';

    el.addEventListener('click', () => {
      animateScroll(targetElement.offsetTop, speed, ease);
    });
  },
};
